import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Moment from 'moment';
import CheckBox from '../../UI/CheckBox';
import Project from '../../lms-shared/UI/Project'
import { ObjectTypeNamesEnum } from "../../../models/ObjectTypeEnum";
import classes from './ImportOldProjects.module.css'
import Loader from "../../lms-shared/UI/Loader/Loader";
import { onKeyDown } from "../../../service";
import SuccessProjectPopup from "../../lms-shared/UI/Popups/SuccessProjectPopup/SuccessProjectPopup";
import { DynamicMessageTypeEnum } from "../../lms-shared/models/DynamicMessageTypeEnum";
import DynamicMessage from "../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { postJson } from "../../../utils";


const ImportOldProjects = ({ closePopup, changeLibraryData, setContentBankItemList, contentBankItemList }) => {
    const texts = useSelector(state => state.translate.texts);
    const applicationId = useSelector(state => state.application.applicationId);
    const direction = useSelector(state => state.translate.direction);
    const { uiData } = useSelector((state) => state.general);
    const [message, setMessage] = useState(null)
    const [messagePopup, setMessagePopup] = useState()
    const [oldProjects, setOldProjects] = useState(null)
    const [load, setLoad] = useState(!oldProjects);

    async function getData() {
        try {
            const response = await postJson('project/filterRange', {}, window.config.ImportProjectsApiUrl);
            setLoad(false);
            const resdata = await response.json();
            resdata.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
            resdata.map(p => p.selected = false);
            setOldProjects(resdata);
        } catch (error) {
            setLoad(false);
            if (error === 404)
                setMessagePopup(
                    <DynamicMessage
                        type={DynamicMessageTypeEnum.Error}
                        confirmFunc={() => setMessagePopup(null)}
                        content={texts.MessageContentOldProjects} />
                );
            else
                setMessagePopup(
                    <DynamicMessage
                        type={DynamicMessageTypeEnum.Error}
                        confirmFunc={() => setMessagePopup(null)}
                        content={texts.MessageContentOldProjects}
                        title={texts.MessageTitleMessagesSetReadRange} />
                );
        }
    }

    useEffect(() => {
        getData()
    }, [])

    function addProject(p) {
        setOldProjects((prev) => {
            const selectedCount = prev.filter(proj => proj.selected).length;

            if (selectedCount >= uiData.importProjectsRange) {
                return prev;
            }

            const addSelectProject = [...prev];
            const index = addSelectProject.indexOf(p);
            addSelectProject[index].selected = true;
            return addSelectProject;
        })
        if (setContentBankItemList && contentBankItemList.length < 15)
            setContentBankItemList([...contentBankItemList, p]);
    }

    function removeProject(p) {
        setOldProjects((prev) => {
            var removeSelectProject = [...prev]
            var index = removeSelectProject.indexOf(p)
            removeSelectProject[index].selected = false
            return removeSelectProject
        })
        if (contentBankItemList && setContentBankItemList) {
            const index = contentBankItemList.indexOf(p);
            if (index > -1) {
                setContentBankItemList(contentBankItemList.splice(index, 1));
            }
        }

    }

    async function importProjects(e) {
        try {
            const projectsIds = oldProjects.filter(p => p.selected).map(pr => pr.id);
            const data = {
                ids: projectsIds,
                refObjectType: ObjectTypeNamesEnum.Application,
                refObjectId: applicationId
            };
            const response = await postJson('project/importRange', data, window.config.ImportProjectsApiUrl); // Adjust the URL as necessary
            if (response.ok) {
                setMessage(
                    <SuccessProjectPopup
                        close={() => setMessage(null)}
                        color={"#E4F7F7"}
                        type="import"
                        title={texts.importProjectsFromLastYear}
                    >
                        <div className={classes.SuccessImportPopup}>{`${texts.SuccessImportPopup}!`}</div>
                    </SuccessProjectPopup>
                );
                if (changeLibraryData) {
                    changeLibraryData('LOAD');
                }
                closePopup(e);
            } else {
                throw new Error(`status from api ${response.status}`);
            }
        } catch (error) {
            setMessagePopup(
                <DynamicMessage
                    type={DynamicMessageTypeEnum.Warn}
                    confirmFunc={() => setMessagePopup(null)}
                    content={texts.MessageContentCannotImportProjects}
                    title={texts.MessageTitleMessagesSetReadRange} />
            );
        }
    }

    return (

        <div className={`${classes[direction]} ${classes.BackDrop}`}>
            <div className={classes.ImportOldProjectsWrapper}>
                {message}
                {messagePopup}
                <div className={classes.Header}>
                    <div className={classes.Title}>{texts.importFromLastSystem}</div>
                    <div className={classes.Circle} onClick={(e) => closePopup(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => closePopup(e))}>
                        <div className={classes.XLine}></div>
                        <div className={`${classes.XLine} ${classes.Rotate}`}></div>
                    </div>
                </div>
                {!load ? oldProjects && oldProjects.length > 0 ?
                    <>
                        <p className={classes.ImportExplanation}>{texts.importFromLastExplanation}</p>
                        <div className={classes.Overflow}>
                            <div className={classes.OldProjects}>
                                {oldProjects.map((p, i) =>
                                    <div className={classes.Project} key={i}>
                                        <CheckBox
                                            checked={p.selected}
                                            onChecked={() => addProject(p)}
                                            onRemoveChecked={() => removeProject(p)}
                                        // value={texts.selectAllClass}
                                        >
                                            <Project
                                                project={p}
                                                descriptionDate={Moment(p.createdDate).format('DD/MM/YY')}
                                                noEditName={true}
                                                oldProject={true} />
                                        </CheckBox>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={classes.ImportButton}>
                            <span className={oldProjects.filter(proj => proj.selected).length >= uiData.importProjectsRange ? classes.DisabledCheck : classes.Counter}>
                                {uiData.importProjectsRange}/   <p className={classes.Selected}>{oldProjects.filter(proj => proj.selected).length}</p>
                            </span>
                            <div className={classes.ImportBtn} onClick={importProjects} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, importProjects)}>{texts.importTo}</div>
                        </div>
                    </>
                    : <div className={classes.NoProjects}>{texts.noProjectsFromLastYear}</div>
                    : <Loader />
                }
            </div>
        </div >
    )
}
export default ImportOldProjects